import { withMotion } from '@hoc/withMotion';
import SimpleMenu from '@stories/Components/Footer/SimpleMenu/SimpleMenu';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import FernBanner from '!file-loader!@img/banners-bg.jpg';
import FernBannerMobile from '!file-loader!@img/banners-bg-mobile.jpg';
import React from 'react';
import FooterStyles from './Footer.styles';
const Footer = ({ copyright, facebookLink, instagramLink, linkedinLink, logo, logoIcon, menu1, menu2, menu3, socialTitle, twitterLink, }) => {
    const [activeMenuId, setActiveMenuId] = React.useState('');
    return (React.createElement(FooterStyles.Container, null,
        React.createElement(FooterStyles.Background, { alt: 'Plant image', draggable: false, loading: "lazy", role: "presentation", src: FernBanner, srcSet: [
                `${FernBannerMobile} 375w`,
                `${FernBannerMobile} 768w`,
                `${FernBanner} 1024w`,
                `${FernBanner} 1400w`,
            ].join(', ') }),
        logoIcon && (React.createElement(FooterStyles.LogoIconBg, { alt: logoIcon.title, loading: "lazy", src: logoIcon.icon })),
        React.createElement(FooterStyles.Inner, null,
            React.createElement(SiteWide, null,
                React.createElement(FooterStyles.Grid, null,
                    logo && (React.createElement(FooterStyles.Col, null,
                        React.createElement(FooterStyles.LogoHolder, { href: logo?.url },
                            React.createElement(FooterStyles.Logo, { alt: logo.title, loading: "lazy", src: logo.icon })))),
                    React.createElement(FooterStyles.Col, null, menu1 && (React.createElement(SimpleMenu, { ...menu1, isActive: activeMenuId === 'menu1', onToggle: () => {
                            if (activeMenuId === 'menu1') {
                                setActiveMenuId('');
                            }
                            else {
                                setActiveMenuId('menu1');
                            }
                        } }))),
                    React.createElement(FooterStyles.Col, null, menu2 && (React.createElement(SimpleMenu, { ...menu2, isActive: activeMenuId === 'menu2', onToggle: () => {
                            if (activeMenuId === 'menu2') {
                                setActiveMenuId('');
                            }
                            else {
                                setActiveMenuId('menu2');
                            }
                        } }))),
                    React.createElement(FooterStyles.Col, null, menu3 && (React.createElement(SimpleMenu, { ...menu3, isActive: activeMenuId === 'menu3', onToggle: () => {
                            if (activeMenuId === 'menu3') {
                                setActiveMenuId('');
                            }
                            else {
                                setActiveMenuId('menu3');
                            }
                        } }))),
                    React.createElement(FooterStyles.Col, null,
                        socialTitle && React.createElement(FooterStyles.SocialTitle, null, socialTitle),
                        React.createElement(FooterStyles.SocialHolder, null,
                            facebookLink && (React.createElement(FooterStyles.SocialLink, { href: facebookLink, rel: "noreferrer", target: "_blank" },
                                React.createElement(FooterStyles.FacebookIcon, null))),
                            twitterLink && (React.createElement(FooterStyles.SocialLink, { href: twitterLink, rel: "noreferrer", target: "_blank" },
                                React.createElement(FooterStyles.TwitterIcon, null))),
                            instagramLink && (React.createElement(FooterStyles.SocialLink, { href: instagramLink, rel: "noreferrer", target: "_blank" },
                                React.createElement(FooterStyles.InstagramIcon, null))),
                            linkedinLink && (React.createElement(FooterStyles.SocialLink, { href: linkedinLink, rel: "noreferrer", target: "_blank" },
                                React.createElement(FooterStyles.LinkedinIcon, null)))))),
                React.createElement(FooterStyles.Legal, null,
                    logoIcon && (React.createElement(FooterStyles.LogoIcon, { alt: logoIcon.title, loading: "lazy", src: logoIcon.icon })),
                    React.createElement(FooterStyles.LegalInner, null,
                        React.createElement(FooterStyles.LegalContent, null, copyright)))))));
};
export default withMotion(Footer);
